// 引入公共模块
import { 
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.faqHandler(); // 常见问题
  },
  faqHandler() {
    // 绑定点击事件
    $('.faq-q').on('click', function () {
      const $item = $(this).parent('.faq-item');
      const isOpen = $item.hasClass('open');

      // 关闭所有已展开项
      $('.faq-item.open').each(function () {
        const $answer = $(this).find('.faq-a');
        $answer.css('maxHeight', '0');
        $(this).removeClass('open');
      });

      // 当前未展开则打开
      if (!isOpen) {
        const $inner = $item.find('.faq-a-inner');
        const $answer = $item.find('.faq-a');
        $answer.css('maxHeight', $inner[0].scrollHeight + 'px');
        $item.addClass('open');
      }
    });
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
